import AxiosInstance from "./AxiosInstance";

const ApiClient = {
  get(url, params) {

    let options = {
      method: 'GET',
      url: url,
      params: {
        ...params
      }
    };

    console.info("ApiClient.get() called. ", JSON.stringify(options));
    return this.callAxios(options);
  },

  post(url, data) {
    const options = {
      method: 'POST',
      url: url,
      data: data
    };
    console.info("ApiClient.post() called. ", JSON.stringify(options));
    return this.callAxios(options);
  },

  put(url, data) {
    const options = {
      method: 'PUT',
      url: url,
      data: data
    };
    console.info("ApiClient.put() called. ", JSON.stringify(options));
    return this.callAxios(options);
  },

  delete(url, data) {
    const options = {
      method: 'DELETE',
      url: url,
      data: data
    };
    console.info("ApiClient.delete() called. ", JSON.stringify(options));
    return this.callAxios(options);
  },

  request(method, url, data, params, responseType) {
    let options = {
      method: method,
      url: url,
      data: data,
      responseType: responseType,
      params: {
        ...params
      }
    };

    console.info("ApiClient.request() called. ", JSON.stringify(options));
    return this.callAxios(options);
  },

  callAxios(options) {
    return new Promise((resolve, reject) => {
      AxiosInstance.request(options)
        .then(response => resolve(response))
        .catch(error => reject(error))
    });
  }
}


export default ApiClient;



